import { jsonResponseHandling } from '../fetch';
import { apiUrl, EVENT_STORE_PATH, fetchWithSubscriptionKey } from '../api-manager';

export const fetchOccupancyEvents = async (from = '') => fetchWithSubscriptionKey(apiUrl(`${EVENT_STORE_PATH}/analytics/occupancy?from=${from}`), { method: 'GET' })
    .then(response => jsonResponseHandling(response))
    .then(data => data);
